// Generate a random captcha code
export const generateCaptchaCode = (length = 5) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
};

// Validate captcha entered by user
export const validateCaptcha = (input, original) => {
  if (!input) return "Captcha is required";

  // case-sensitive captcha (exact match)
  if (input.trim() !== original)
    return "Invalid captcha";

  return "";
};
